<template>
  <div class="livestream-block" :style="{ padding: blockPadding }">
    <template v-if="isBuilderContext() && !isPresent(provider)">
      <block-placeholder
        icon="live_tv"
        :text="$t('components.blocks.liveStreamBlock.liveStreamTitle')"
      />
    </template>
    <template v-else-if="!isPresent(video)">
      <block-placeholder
        icon="missed_video_call"
        :text="$t('components.blocks.liveStreamBlock.videoNotSetup')"
      />
    </template>
    <template v-else>
      <livestream
        :id="id"
        :provider="provider"
        :remote-id="remoteId"
        :video="video"
        :message-thread-id="messageThreadId"
      />
    </template>
  </div>
</template>

<script>
import { LIVESTREAM_PROVIDERS } from "@/lib/stream-utils"
import { withRatio, toPadding } from "@shared/block-ratio"
import { isBuilderContext, isPresent } from "@/lib/utils"

import Livestream from "@/components/blocks/livestream/Livestream"

export default {
  components: {
    Livestream,
    BlockPlaceholder: () => import("@/components/stream/BlockPlaceholder")
  },

  props: {
    id: { type: [Number, String], required: true },
    messageThreadId: { type: [Number, String], required: true },
    provider: { type: String, default: null },
    remoteId: { type: String, default: null },
    video: { type: Object, default: () => ({}) },
    spaceXRatio: { type: Number, default: 0 },
    spaceTopRatio: { type: Number, default: 0 },
    spaceBottomRatio: { type: Number, default: 0 }
  },

  data() {
    return {
      LIVESTREAM_PROVIDERS
    }
  },

  computed: {
    blockPadding() {
      return toPadding(
        this.spaceTopRatio,
        this.spaceXRatio,
        this.spaceBottomRatio
      )
    }
  },

  methods: {
    withRatio,
    isBuilderContext,
    isPresent
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/mixins";

.livestream-block {
  @include full-height;
}
</style>
